<mv-popup show="{{ isOpen }}" title="Invités ? Cherchez une liste de Mariage !">
    <div class="wrapper">
        <form (ngSubmit)="searchList()" #inputSearchList="ngForm" novalidate>
            <div class="wrapper__inputsearch">
                <input
                    type="text"
                    name="searchInput"
                    [(ngModel)]="searchInput"
                    required
                    minlength="3"
                    #searchInputVar="ngModel"
                />
                <button type="submit" [disabled]="!inputSearchList.valid">
                    <i class="mv-icons--simple--search"></i>
                </button>
            </div>
            <div class="wrapper__inputsearch__message">
                Vous pouvez rechercher par prénom et nom
                <span> (3 caractères minimun)</span>
            </div>
        </form>
        <div class="wrapper__wedding">
            <h3>RÉSULTAT DE VOTRE RECHERCHE</h3>
            <div class="wrapper__wedding__liste" *ngIf="datasSearch.length > 0 || firstShearch; else elseBlock">
                <a
                    *ngFor="let datasSearch of datasSearch"
                    class="wrapper__wedding__liste__item link-style2"
                    [href]="datasSearch.link"
                >
                    <i class="mv-icons--simple--suppliers"></i>
                    <p>
                        {{ datasSearch.contributionTitle }}
                    </p>
                    <button>Choisir cette liste</button>
                </a>
            </div>

            <ng-template #elseBlock>
                <p class="wrapper__wedding__message">
                    Oups, aucune liste ne répond à votre recherche ! <br />la liste que vous cherchez est peut-être
                    privée, n'hésitez pas à contacter son propriétaire pour obtenir le lien
                </p>
            </ng-template>
        </div>
    </div>
</mv-popup>
